import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Games from "@/pages/Games";
import Team from "@/pages/Team";
import About from "@/pages/About";

function App() {
    return (
        <div className="App grain min-h-screen bg-[#000000] text-slate-100">
            <BrowserRouter>
                <Navbar />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/games" element={<Games />} />
                        <Route path="/team" element={<Team />} />
                        <Route path="/about" element={<About />} />
                    </Routes>
                </main>
                <Footer />
            </BrowserRouter>
        </div>
    );
}

export default App;
